import { watch, type Ref } from 'vue';

export const focusUnlessInside = (element: HTMLElement | null | undefined): void => {
  if (!element || element.contains(document.activeElement)) return;
  element.focus();
};

export const useFocusWhenSelected = (
  isSelected: () => boolean,
  isEnabled: () => boolean,
  element: Ref<HTMLElement | null | undefined>
): void => {
  watch(isSelected, (selected) => {
    if (selected && isEnabled()) focusUnlessInside(element.value);
  });
};
